<script lang="ts" setup></script>

<template>
    <div class="red-point" />
</template>

<style lang="scss" scoped>
.red-point {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: $red-500;
    cursor: pointer;
}
</style>
